import { modal, menu } from '../action/widget.action';
import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

// initial state
const initialState = fromJS({
    modal: { show: false },
    message: { show: false },
    menu: { open: false },
    modalEx: { mode: 0 },
    modalUpload: { open: true },
    modalStart: { status: 0 },
});

// reducer
export default handleActions(
    {
        [modal.INITIALIZE]: () => initialState,
        [modal.SHOW_MODAL]: (state, action) => {
            return state.setIn(['modal', 'show'], action.payload);
        },
        [modal.SHOW_MESSAGE]: (state, action) => {
            return state.setIn(['message', 'show'], action.payload);
        },
        [modal.SHOW_MODAL_EX]: (state, action) => {
            return state.setIn(['modalEx', 'mode'], action.payload);
        },
        [modal.SHOW_MODAL_UPLOAD_FILE]: (state, action) => {
            return state.setIn(['modalUpload', 'open'], action.payload);
        },
        [modal.SHOW_START]: (state, action) => {
            return state.setIn(['modalStart', 'status'], action.payload);
        },

        [menu.INITIALIZE]: () => initialState,
        [menu.SHOW_MENU]: (state, action) => {
            return state.setIn(['menu', 'open'], action.payload);
        },
    },
    initialState,
);
